export const fileDownloadStateEnum = Object.freeze({
    "READY":     1,
    "RUNNING":   2
});